module.exports = __webpack_public_path__ + "static/logo-18e74f59d554daf6a4b67226b98fcd17.png";